(function(){
  var h=document.querySelector('[data-oh]');if(!h)return;
  var root=document.documentElement;
  // sticky shadow / slim on scroll
  var st=false;function onS(){var s=window.scrollY>40;if(s!==st){st=s;h.classList.toggle('is-stuck',s);}}
  window.addEventListener('scroll',onS,{passive:true});onS();
  // mega menu
  var mega=h.querySelector('[data-oh-mega]');
  if(mega){var btn=mega.querySelector('button'),tm;
    function set(o){mega.classList.toggle('is-open',o);btn.setAttribute('aria-expanded',o);}
    mega.addEventListener('mouseenter',function(){clearTimeout(tm);set(true);});
    mega.addEventListener('mouseleave',function(){tm=setTimeout(function(){set(false);},120);});
    btn.addEventListener('click',function(){set(!mega.classList.contains('is-open'));});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')set(false);});
    document.addEventListener('click',function(e){if(!mega.contains(e.target))set(false);});
  }
  // search toggle
  var sb=h.querySelector('[data-oh-search]'),sf=document.getElementById('oh-search');
  if(sb&&sf)sb.addEventListener('click',function(){var o=sf.hidden;sf.hidden=!o;sb.setAttribute('aria-expanded',o);if(o)sf.querySelector('input').focus();});
  // drawer
  var d=document.querySelector('[data-oh-drawer]'),ob=h.querySelector('[data-oh-open]');
  function dr(o){if(!d)return;d.classList.toggle('is-open',o);d.setAttribute('aria-hidden',!o);root.classList.toggle('oh-lock',o);if(ob)ob.setAttribute('aria-expanded',o);}
  if(ob)ob.addEventListener('click',function(){dr(true);});
  if(d){d.querySelectorAll('[data-oh-close]').forEach(function(x){x.addEventListener('click',function(){dr(false);});});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')dr(false);});}
  // live cart count
  var c=h.querySelector('[data-oh-count]');
  function upd(n){if(!c)return;c.textContent=n;c.hidden=!n;}
  function refresh(){fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(j){upd(j.item_count);}).catch(function(){});}
  if(window.fetch){var of=window.fetch;window.fetch=function(){var u=arguments[0];u=typeof u==='string'?u:(u&&u.url)||'';var p=of.apply(this,arguments);
    if(/\/cart\/(add|change|update|clear)/.test(u))p.then(function(){setTimeout(refresh,50);});return p;};}
  ['cart:change','cart:updated','cart:refresh'].forEach(function(ev){document.addEventListener(ev,refresh);});
  window.addEventListener('pageshow',function(e){if(e.persisted)refresh();});
})();
